import React, { useState } from "react";
import Index from "../../Index";
import PagesIndex from "../../../container/PagesIndex";

const SahayApplicaitonLog = ({
  open,
  handleClose,
  handleComplete,
  setReason,
  data,
  isDisabled
}) => {
    
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
  };

  const [error, setError] = useState("");
  return (
    <Index.Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="modal-delete modal"
    >
      <Index.Box sx={style} className="delete-modal-inner-main modal-inner">
        <Index.Box className="remark-textarea-details">
          <Index.Box className="set-text-area ">
            <Index.Typography
              variant="label"
              component="label"
              className="input-label"
            >
              Activity Log Of  <span className="user-name">{data?.Name || `${data?.mem_fname || ''} ${data?.mem_mname || ''} ${data?.mem_lname || ''}`.trim()}
              </span>
            </Index.Typography>
            <Index.Box className="">
                    <Index.TableContainer
                      sx={{ maxHeight: 480 }}
                      // component={Index.Paper}
                      className="table-container user-sahay-container scroll-table common-table-container-custom"
                    >
                      <Index.Table
                        stickyHeader
                        aria-label="sticky table"
                        className="table-design-main barge-table user-sahay-table"
                      >
                        <Index.TableHead className="user-sahay-thead">
                          <Index.TableRow className="user-sahay-tr">
                            
                            <Index.TableCell
                              className="user-sahay-td"
                              align="left"
                            >
                              Activity log
                            </Index.TableCell>
                            <Index.TableCell
                              className="user-sahay-td"
                              align="left"
                            >
                              Updated Date&Time
                            </Index.TableCell>
                           
                          </Index.TableRow>
                        </Index.TableHead>
                        <Index.TableBody
                          className="user-sahay-tbody"
                        >
                          {handleComplete?.length ? (
                            handleComplete?.map((row, index) => {
                              return (
                                <Index.TableRow
                                  key={index}
                                  className={`${
                                    row?.SaveSahay == 0
                                      ? "highlight-save-sahay"
                                      : ""
                                  }`}
                                >
                                  <Index.TableCell align="left">
                                    {row?.role}: {row?.actionBy} change status {row?.status} 
                                  </Index.TableCell>
                                  <Index.TableCell align="left">
                                    {row?.createdAt}
                                  </Index.TableCell>

                                </Index.TableRow>
                              );
                            })
                          ) : (
                            <PagesIndex.NoRecordFound colSpan={14} />
                          )}
                        </Index.TableBody>
                      </Index.Table>
                    </Index.TableContainer>
                  </Index.Box>
          </Index.Box>

        </Index.Box>
      </Index.Box>
    </Index.Modal>
  );
};

export default SahayApplicaitonLog;
